export default "__VITE_ASSET__BTwTGp4K__"